export const routes = {
  auth: "/login",
  listing: "/",
  documents: "/documents",
  holding: "/holding",
  transactions: "/transactions",
  listingDetail: "/instrument/:id",
  inventory: "/inventory",
  retirementRequests: "/retirement-requests",
  retirementHistory: "/retirement-history",
}

export default routes
